import React, { useContext, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Timeout } from '../../../functions/functions';
import ShowErrorMsg from '../../../HtmlComponents/ShowErrorMsg';
import ButtonsForm from '../../../HtmlComponents/ButtonsForm';
import { ShowAdsInfoContext } from '../types';
import { DeleteAdsInfoPhotoApi } from '../../../redux/adsinfo/adsInfoApiCalls';

interface props {
  modal: boolean,
  toggle: any
}

const DeletePhotoAdsInfo: React.FC<props> = ({ modal, toggle }) => {
  const { selectedAdsInfo, selectedPhoto, setShowSuccessMsg } = useContext(ShowAdsInfoContext)

  const dispatch: any = useDispatch()

  const [errors, setErrors] = useState<string[]>([])

  const handleSubmit = async (e: any) => {
    e.preventDefault()
    const response: any = await dispatch(DeleteAdsInfoPhotoApi(selectedAdsInfo._id, selectedPhoto))
    
    if(response === true) {
      setShowSuccessMsg(true)
      setTimeout(() => setShowSuccessMsg(false), Timeout)
      toggle()
    } else {
      setErrors(response)
    }
  }

  return (
    <>
      {modal && (
        <>
          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div
              className="fixed inset-0 w-full h-full bg-black opacity-40"
              onClick={toggle}
            ></div>
            <div className="flex items-center min-h-screen px-4 py-8">
              <div className="relative w-full max-w-lg p-4 mx-auto bg-white rounded-md shadow-lg">
                <div className="mt-3">
                  {/* Start Modal Body */}
                  <form
                    className="mt-2 sm:ml-4 sm:text-left"
                    onSubmit={handleSubmit}
                  >
                    <ShowErrorMsg errors={errors} setErrors={setErrors} />
                    <ButtonsForm typeBtn='Supprimer' toggle={toggle} />
                  </form>
                  {/* End Modal Body */}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default DeletePhotoAdsInfo
